import React from 'react'

export default function RatingField(props) {
  const skill = props.skill
  const points = props.points
  const ratingHandler = props.ratingHandler

  return (
    <fieldset
      name={skill}
      className="flex flex-row justify-center star-rating h-14 border-b-1 border-b-gray-300 border-opacity-50 p-0 m-0"
    >
      {[1, 2, 3, 4, 5].map((value) => (
        <input
          onChange={ratingHandler}
          type="radio"
          name={skill}
          value={value}
          checked={value === points}
          key={value}
        />
      ))}
    </fieldset>
  )
}
